<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.drillDepth')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/slagIronPara"><span>{{$t('tlt.slagIronPara')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/drillDepth"><span>{{$t('tlt.drillDepth')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('drillDepth')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <mes-filter entity="drillDepth" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="drillDepthListTabel" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionResult">
                        <div class="card-body">
                            <mmf-table entity="drillDepth" inline-actions-disabled singleChoice></mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MmfTable from "@/components/MmfTable";
import MesFilter from '@/components/MesFilter'

// 常量
const moduleName = "drillDepth";

export default {
  components: {
    MmfTable,
    MesFilter
  },
  methods: {
    ...mapActions(moduleName, ["jumpToEdit"]),
    ...mapActions("base", ["MMFLoadRows", "MMFNew"]),
  },
  data() {
    return {
      moduleName: moduleName
    };
  }
};
</script>